/**
 * VendorStatusService
 * Service for managing vendor statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor status CRUD operations
 */
export class VendorStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorStatusService.DEFAULT_SERVICE_PATH,
            basePath: VendorStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorStatusService.DEFAULT_SERVICE_PATH = 'vendors';
VendorStatusService.BASE_PATH = 'api/vendor-statuses';
//# sourceMappingURL=VendorStatusService.js.map